import * as Services from "../services/Services"
import * as Url from "../services/Url"


export const getAllTenants = async() => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_TENANTS, token)
  return res;
};

export const getTenantDetails = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.GET(`${Url.GET_TENANT_DETAILS}/${id}`, token)
  return res;
};

export const addTenant = async(payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_TENANT, payload, token)
  return res;
};
export const updateTenant = async(id, payload) => {
  let token = localStorage.getItem("token");
  let res = await Services.PUT(`${Url.UPDATE_TENANT}/${id}`, payload, token)
  return res;
};
export const deleteTenantByID = async(id) => {
  let token = localStorage.getItem("token");
  let res = await Services.DELETE(`${Url.DELETE_TENANT}/${id}`, {}, token)
  return res;
};
